import { Injectable } from '@angular/core';
import {HttpRequest, HttpResponse} from '@angular/common/http';
import {Har} from '../data/har';
import {ApiService} from '../../app-common/services/server/api.service';

@Injectable({
  providedIn: 'root'
})
export class HarService {

  // Make sure this is false in production builds.
  // It causes HTTP GET requests to be sent twice.
  includeResponses: boolean = false;
  log: Har;

  constructor(public httpService: ApiService) {
    this.httpService = httpService;
    this.log = new Har(this, new Date());
    setTimeout(async () => {
    }, 10000);
  }

  addToLog(request: HttpRequest<any>, data: HttpResponse<any>) {
    this.log.addEntry(this, request, data);
  }

  async sendHar() {
    const json = JSON.stringify(this.log);
    const response = await this.httpService.applicationApiClient.postFile('Har', json);
  }
}
